import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App';
import './styles/global.css';
import { loadCategories } from './services/categories';

// 启动预热: 拉一次后端分类配置 (失败自动用默认兜底, 不阻塞渲染).
loadCategories();

// 用 HashRouter: 静态托管零配置, 所有路由在 # 后面, 服务器永远只返回 /community/index.html.
// URL 形如 https://hipiido.cloud/community/#/from-app?intent=xxx&t=yyy
// 不需要 basename (hash 部分跟 base 路径无关).
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>,
);
